import { PAGE_HELP } from "./pageHelpRegistry";

export function resolvePageHelpKey(selectedPage) {
  if (!selectedPage) return null;
  if (PAGE_HELP[selectedPage]) return selectedPage;
  return null;
}

export function pageHasHelp(selectedPage) {
  return resolvePageHelpKey(selectedPage) != null;
}
